import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  ListCreditsSupplierQuery,
  ListSuppliersQuery,
  Supplier,
  SupplierCredits,
  SupplierReduced,
} from './Suppliers.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/suppliers`;

export async function listSuppliers(
  params?: ListSuppliersQuery,
): Promise<PageResult<Supplier>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Supplier>;
}

export async function listSuppliersReduced(params?: ListSuppliersQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/reduced`,
    params,
  )) as unknown;

  return result as PageResult<SupplierReduced>;
}

export async function getSupplier(id: number): Promise<Supplier> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Supplier;
}

export async function getSupplierReduced(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/reduced`,
    null,
  )) as unknown;

  return result as SupplierReduced;
}

export async function createSupplier(obj: Supplier): Promise<Supplier> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Supplier;
}

export async function updateSupplier(obj: Supplier): Promise<Supplier> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as Supplier;
}

export async function deleteSupplier(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function activeSupplier(obj: {
  id: number;
  activeSupplier: boolean;
}) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}/${obj.activeSupplier ? 'inactive' : 'active'}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function inactiveSupplier(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/inactive`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function listCreditsSupplier(
  params?: ListCreditsSupplierQuery,
): Promise<PageResult<SupplierCredits>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${params?.supplierId}/credit/`,
    params,
  )) as unknown;

  return result as PageResult<SupplierCredits>;
}
